module.exports = __webpack_public_path__ + "static/media/recevier.885c380b.png";